import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-treatment-plan-details',
  templateUrl: './treatment-plan-details.component.html',
  styleUrls: ['./treatment-plan-details.component.scss'],
})
export class TreatmentPlanDetailsComponent implements OnInit {
  @Input() treatmentData: any;
  constructor() {}

  ngOnInit(): void {}

  getCommaSeparatedTargets(targets: any): string {
    if (Array.isArray(targets) && targets.length > 0) {
      return targets.join(', ');
    }
    return 'N/A';
  }
}
